import React from "react";
import { FaCheckSquare } from "react-icons/fa";
import Benefit2Image from '../../assets/img/bitcoin2.png';

const benefits = [
  "We don’t replace Africa’s financial culture — We digitize it, secure it, and scale it.",
  "Purpose-locked funds → no theft or misuse",
  "Automated governance → reduced human error",
  "Role-based controls → enhanced accountability",
  "Participation from anywhere → geography disappears",
  "Interoperability across networks → no SIM juggling",
  "Trust by design. Growth by technology."
];

const WhyMastaKash = () => {
  return (
    <section className="bg-purple-50 py-16">
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        
        {/* Image */}
        <div className="lg:w-1/2 flex justify-center">
          <img 
            src={Benefit2Image} 
            alt="MastaKash Benefits" 
            className="rounded-2xl shadow-xl hover:scale-105 transition-transform duration-500"
          />
        </div>

        {/* Text Content */}
        <div className="lg:w-1/2">
          <h1 className="text-4xl font-bold text-purple-900 mb-4">Why choose MastaKash?</h1>
          <p className="text-purple-800 text-lg mb-8">
            We bridge formal and informal finance through compliant, transparent, and auditable systems.
          </p>

          {/* Benefits List */}
          <ul className="space-y-4">
            {benefits.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <FaCheckSquare className="text-orange-500 mt-1 flex-shrink-0" size={20} />
                <span className="text-purple-800 text-base">{item}</span>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
};

export default WhyMastaKash;
